import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import logoBM from "./assets/logo-bm.png";
import logoNEPSI from "./assets/logo-NEPSI.png";
import logoCerroNegro from "./assets/logo-cerro-negro.png";
import logoEnami from "./assets/enami-logo.jpg";
import logoCenizas from "./assets/logo-cenizas.png";
import logoAndesControls from "./assets/logo-andes-controls.png";
import logoPSCorp from "./assets/logo-pscorp.svg";
import logoEscondida from "./assets/logo-minera-escondida.png";
import logoGe from "./assets/logo-ge.svg";
import logoZaldivar from "./assets/logo-zaldivar.svg";
import logoGlencore from "./assets/logo-glencore.svg";
import logoCodelco from "./assets/logo-codelco.svg";
import logoFlorida from "./assets/logo-florida.svg";
// Imágenes nuevas de WhatsApp
import rectificador01 from "./assets/Imagen de WhatsApp 2025-10-09 a las 21.05.10_78e6c61c.jpg";
import rectificador02 from "./assets/Imagen de WhatsApp 2025-10-09 a las 21.05.10_446d6e55.jpg";
import rectificador03 from "./assets/Imagen de WhatsApp 2025-10-09 a las 21.05.10_f62e1393.jpg";
import rectificador04 from "./assets/Imagen de WhatsApp 2025-10-09 a las 21.05.10_171278fa.jpg";
import rectificador05 from "./assets/Imagen de WhatsApp 2025-10-09 a las 21.05.09_cd3e7d0a.jpg";
import rectificador06 from "./assets/Imagen de WhatsApp 2025-10-09 a las 21.05.09_362a7066.jpg";
import rectificador07 from "./assets/Imagen de WhatsApp 2025-10-09 a las 21.05.09_70dcf04c.jpg";
import rectificador08 from "./assets/Imagen de WhatsApp 2025-10-09 a las 21.05.08_81bb7703.jpg";
import rectificador09 from "./assets/Imagen de WhatsApp 2025-10-09 a las 21.05.08_c8a88806.jpg";
import rectificador10 from "./assets/Imagen de WhatsApp 2025-10-09 a las 21.05.08_884ae6ef.jpg";

// Imágenes originales de ENAMI
import enami01 from "./assets/WhatsApp Image 2025-09-02 at 19.14.09.jpeg";
import enami02 from "./assets/WhatsApp Image 2025-09-02 at 19.14.11.jpeg";
import enami03 from "./assets/WhatsApp Image 2025-09-02 at 19.14.13.jpeg";
import enami04 from "./assets/WhatsApp Image 2025-09-02 at 19.14.15.jpeg";
import enami05 from "./assets/WhatsApp Image 2025-09-02 at 19.14.52.jpeg";
import enamiMT01 from "./assets/WhatsApp Image 2025-09-08 at 17.21.15.jpeg";
import enamiMT02 from "./assets/WhatsApp Image 2025-09-08 at 17.21.15(1).jpeg";
import enamiMT03 from "./assets/WhatsApp Image 2025-09-08 at 17.21.16.jpeg";

export default function LandingBMNEPSI() {
  const [darkMode, setDarkMode] = useState(true);
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [lightboxCategoryIndex, setLightboxCategoryIndex] = useState(null);
  const [reduceMotion, setReduceMotion] = useState(false);
  const [carouselPositions, setCarouselPositions] = useState([0, 0, 0, 0]);
  const [visibleItems, setVisibleItems] = useState(3); // Número de elementos visibles por defecto (3 para desktop)
  // Estado del formulario de contacto
  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactMessage, setContactMessage] = useState("");
  const CONTACT_EMAIL = "contacto@bmse.cl"; // Cambia este correo si corresponde
  const WHATSAPP_ERIC = "+56981491031";
  const WHATSAPP_RAFAEL = "+56995094647";

  useEffect(() => {
    try {
      const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      setReduceMotion(mediaQuery.matches);
      const onChange = (e) => setReduceMotion(e.matches);
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener("change", onChange);
        return () => mediaQuery.removeEventListener("change", onChange);
      } else {
        // Fallback for older browsers
        mediaQuery.addListener(onChange);
        return () => mediaQuery.removeListener(onChange);
      }
    } catch {
      // no-op on environments without matchMedia
    }
  }, []);

  // Efecto para manejar el número de elementos visibles según el tamaño de pantalla
  useEffect(() => {
    const updateVisibleItems = () => {
      const width = window.innerWidth;
      if (width < 640) { // sm
        setVisibleItems(1);
      } else if (width < 1024) { // md y lg
        setVisibleItems(2);
      } else {
        setVisibleItems(3); // xl y superiores
      }
    };

    updateVisibleItems();
    window.addEventListener('resize', updateVisibleItems);
    return () => window.removeEventListener('resize', updateVisibleItems);
  }, []);

  const handleContactSubmit = (e) => {
    e?.preventDefault?.();
    const subject = `Solicitud de cotización — ${contactName || "Contacto web"}`;
    const lines = [
      `Nombre: ${contactName || ""}`,
      `Email: ${contactEmail || ""}`,
      `Teléfono: ${contactPhone || ""}`,
      "",
      "Mensaje:",
      contactMessage || "",
    ];
    // Use CRLF for better compatibility and percent-encoding (no '+')
    const body = lines.join("\r\n");
    const subjectEnc = encodeURIComponent(subject);
    const bodyEnc = encodeURIComponent(body);
    const href = `mailto:${CONTACT_EMAIL}?subject=${subjectEnc}&body=${bodyEnc}`;
    window.location.href = href;
  };

  const handleCarouselNext = (categoryIndex) => {
    setCarouselPositions(prev => {
      const newPositions = [...prev];
      const category = galleryCategories[categoryIndex];
      const maxPosition = Math.max(0, category.items.length - visibleItems);
      newPositions[categoryIndex] = Math.min(newPositions[categoryIndex] + 1, maxPosition);
      return newPositions;
    });
  };

  const handleCarouselPrev = (categoryIndex) => {
    setCarouselPositions(prev => {
      const newPositions = [...prev];
      newPositions[categoryIndex] = Math.max(0, newPositions[categoryIndex] - 1);
      return newPositions;
    });
  };

  const galleryCategories = [
    {
      title: "Mantenimiento de Rectificador de Alta Corriente",
      items: [
        {
          src: enami01,
          alt: "Rectificador de alta corriente controlado: venta y fabricación (vista 1)",
          caption: "Rectificador de alta corriente controlado (venta y fabricación)",
        },
        {
          src: rectificador01,
          alt: "Servicios para rectificadores de alta corriente",
          caption: "Servicio de Mantenimiento de Rectificador de Alta Corriente",
        },
        {
          src: rectificador02,
          alt: "Servicios para rectificadores de alta corriente",
          caption: "Servicio de Mantenimiento de Rectificador de Alta Corriente",
        },
        {
          src: rectificador03,
          alt: "Servicios para rectificadores de alta corriente",
          caption: "Servicio de Mantenimiento de Rectificador de Alta Corriente",
        },
        {
          src: rectificador04,
          alt: "Servicios para rectificadores de alta corriente",
          caption: "Servicio de Mantenimiento de Rectificador de Alta Corriente",
        },
        {
          src: rectificador05,
          alt: "Servicios para rectificadores de alta corriente",
          caption: "Servicio de Mantenimiento de Rectificador de Alta Corriente",
        },
        {
          src: rectificador06,
          alt: "Servicios para rectificadores de alta corriente",
          caption: "Servicio de Mantenimiento de Rectificador de Alta Corriente",
        },
        {
          src: rectificador07,
          alt: "Servicios para rectificadores de alta corriente",
          caption: "Servicio de Mantenimiento de Rectificador de Alta Corriente",
        },
        {
          src: rectificador08,
          alt: "Servicios para rectificadores de alta corriente",
          caption: "Servicio de Mantenimiento de Rectificador de Alta Corriente",
        },
        {
          src: rectificador09,
          alt: "Servicios para rectificadores de alta corriente",
          caption: "Servicio de Mantenimiento de Rectificador de Alta Corriente",
        },
        {
          src: rectificador10,
          alt: "Servicios para rectificadores de alta corriente",
          caption: "Servicio de Mantenimiento de Rectificador de Alta Corriente",
        },
      ]
    },
    {
      title: "Suministro Rectificador de Emergencia",
      items: [
        {
          src: enami02,
          alt: "Rectificador de alta corriente controlado: venta y fabricación (vista 2)",
          caption: "Suministro rectificador de emergencia",
        }, 
        {
          src: enami03,
          alt: "Rectificador de alta corriente controlado: venta y fabricación (vista 3)",
          caption: "Cableado y ordenamiento interno (alta corriente)",
        },
        {
          src: enami04,
          alt: "Rectificador de alta corriente controlado: venta y fabricación (vista 4)",
          caption: "Integración de control y potencia (alta corriente)",
        },
        {
          src: enami05,
          alt: "Rectificador de alta corriente controlado: venta y fabricación (vista 5)",
          caption: "Verificación final de ensamblaje (alta corriente)",
        },
      ]
    },
    {
      title: "Suministro de Celda de Media Tensión",
      items: [
        {
          src: enamiMT01,
          alt: "Celda de media tensión: gabinete exterior",
          caption: "Celda MT: gabinete exterior (venta y fabricación)",
        },
        {
          src: enamiMT02,
          alt: "Celda de media tensión: paneles internos",
          caption: "Celda MT: paneles y mando (venta y fabricación)",
        },
        {
          src: enamiMT03,
          alt: "Celda de media tensión: placa y diagrama",
          caption: "Celda MT: placa de identificación y diagrama",
        },
      ]
    },
  ];

  // Crear array plano para el lightbox
  const allGalleryItems = galleryCategories.flatMap(category => category.items);

  // --- Datos de Clientes con logos (se pueden reemplazar por archivos locales) ---
  const logoMap = {
    "ENAMI": logoEnami,
    "Enami El Salado": logoEnami,
    "Enami Antonio Matta": logoEnami,
    "ENAMI Taltal": logoEnami,
    "Enami Vallenar": logoEnami,
    "Cerro Negro": logoCerroNegro,
    "Minera Franke (Grupo Ceniza)": logoCenizas,
    "NEPSI": logoNEPSI,
    "GE Power": logoGe,
    "Andes Controls": logoAndesControls,
    "PS Corp Chile SpA": logoPSCorp,
    "Grupo Minero Cenizas": logoCenizas,
    "Minera Escondida": logoEscondida,
    "Minera Zaldívar": logoZaldivar,
    "Minera Lomas Bayas": logoGlencore,
    "Codelco El Teniente": logoCodelco,
    "Codelco Chuquicamata": logoCodelco,
    "Minera Florida": logoFlorida,
  };

  const logoFallback = "https://images.unsplash.com/photo-1581091012184-7c54c201a01d?q=80&w=1200&auto=format&fit=crop";

  const contratosVigentes = [
    "Enami El Salado",
    "Enami Antonio Matta",
    "Enami Vallenar",
    "ENAMI Taltal",
    "Cerro Negro",
    "Minera Franke (Grupo Ceniza)",
  ];

  const clientesListado = [
    "NEPSI",
    "GE Power",
    "Andes Controls",
    "PS Corp Chile SpA",
    "Grupo Minero Cenizas",
  ];

  const serviciosEjecutados = [
    "Minera Escondida",
    "Minera Zaldívar",
    "Minera Lomas Bayas",
    "Codelco El Teniente",
    "Codelco Chuquicamata",
    "Minera Florida",
  ];

  const logoFor = (name) => logoMap[name] || logoFallback;

  // Carruseles responsivos: móvil horizontal, escritorio en grilla
  const allClientes = Array.from(new Set([...contratosVigentes, ...clientesListado, ...serviciosEjecutados]));

  // helpers de gradientes para títulos neutros (línea 1 y 3)
  const titleNeutral =
    darkMode
      ? "from-white via-white to-white/80"
      : "from-slate-900 via-slate-900 to-slate-800";

  return (
    <div
      className={`min-h-screen relative ${darkMode ? "text-slate-100" : "text-slate-900"
        }`}
    >
      {/* --- Decorativo: gradiente oscuro + glows + grilla (solo en dark) --- */}
      {darkMode && (
        <div className="pointer-events-none absolute inset-0 -z-20 hidden md:block overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-[#0b0b0b] via-[#121212] to-[#0b0b0b]" />
          <div className="absolute top-20 left-10 h-[24rem] w-[24rem] rounded-full blur-3xl opacity-20 bg-brand-orange" />
          <div className="absolute bottom-20 right-10 h-[20rem] w-[20rem] rounded-full blur-3xl opacity-10 bg-brand-green" />
          <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.04)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.04)_1px,transparent_1px)] bg-[size:24px_24px]" />
        </div>
      )}

      {/* --- Decorativo: gradiente claro + glows + grilla (solo en light) --- */}
      {!darkMode && (
        <div className="pointer-events-none absolute inset-0 -z-20 hidden md:block overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-slate-50 via-slate-100 to-slate-50" />
          <div className="absolute top-20 left-10 h-[24rem] w-[24rem] rounded-full blur-3xl opacity-15 bg-brand-orange" />
          <div className="absolute bottom-20 right-10 h-[20rem] w-[20rem] rounded-full blur-3xl opacity-15 bg-brand-green" />
          <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] bg-[size:24px_24px]" />
        </div>
      )}

      {/* Navbar */}
      <header
        className={`sticky top-0 z-40 md:backdrop-blur border-b ${darkMode
          ? "supports-[backdrop-filter]:bg-black/40 border-white/10"
          : "bg-white/80 border-slate-200"
          }`}
      >
        <nav className="mx-auto max-w-7xl px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={logoBM} alt="B&M Electric Service" className="h-9 w-auto drop-shadow" />
            <div className="leading-tight">
              <p className="font-semibold">B&M Electric Service SPA</p>
            </div>
          </div>

          <div className="hidden md:flex items-center gap-6 text-sm">
            {[
              ["Inicio", "#inicio"],
              ["Actividades", "#actividades"],
              ["Clientes", "#clientes"],
              ["Rectificadores", "#servicios-rectificadores"],
              ["Tableros y Control", "#tableros"],
              ["Mantenimiento", "#mantenimiento"],
            ].map(([t, href]) => (
              <a
                key={t}
                href={href}
                className={`transition ${darkMode
                  ? "text-slate-300 hover:text-white"
                  : "text-slate-800 hover:text-brand-orange"
                  }`}
              >
                {t}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <a
              href="#contacto"
              className="group rounded-2xl bg-gradient-to-r from-brand-orange to-brand-green px-4 py-2 font-semibold text-white shadow-[0_10px_25px_-10px_rgba(232,97,44,0.6)]"
            >
              <span className="inline-block">Cotizar ahora</span>
            </a>

            {/* Toggle Dark/Light */}
            <button
              onClick={() => setDarkMode((v) => !v)}
              aria-label="Alternar modo oscuro/claro"
              className={`ml-2 rounded-full p-2 border transition
                ${darkMode
                  ? "border-white/20 text-slate-200 hover:bg-white/10"
                  : "border-slate-400 text-slate-800 hover:bg-slate-100"
                }`}
              title={darkMode ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
            >
              {darkMode ? "☀️" : "🌙"}
            </button>
          </div>
        </nav>
      </header>

      {/* Hero */}
      <section id="inicio" className="relative overflow-hidden">
        <div className="mx-auto max-w-7xl px-6 py-20 md:py-24 grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            {...(reduceMotion
              ? {}
              : { initial: { opacity: 0, y: 10 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.5 } })}
          >
            {/* Logo ordenado + título */}
            <div className="grid grid-cols-1 md:grid-cols-[auto,1fr] items-center gap-4 md:gap-6">
              <div className="shrink-0 mx-auto md:mx-0">
                <div
                  className={`h-28 w-28 md:h-40 md:w-40 rounded-2xl grid place-items-center shadow-sm border
                    ${darkMode ? "bg-white/5 border-white/10" : "bg-slate-100 border-slate-200"}`}
                >
                  <img src={logoBM} alt="B&M Logo" className="h-20 w-auto md:h-24" loading="eager" decoding="async" />
                </div>
              </div>

              <h1 className="text-4xl md:text-4xl font-extrabold tracking-tight leading-tight text-center md:text-left">
                <span className={`bg-gradient-to-r ${titleNeutral} bg-clip-text text-transparent`}>
                  Soluciones en
                </span>
                <span className="md:hidden">{' '}</span>
                <br className="hidden md:block" />
                <span className="bg-gradient-to-r from-brand-orange via-amber-300 to-brand-orange bg-clip-text text-transparent">
                  Sistemas de Control y
                </span>
                <span className="md:hidden">{' '}</span>
                <br className="hidden md:block" />
                <span className={`bg-gradient-to-r from-brand-orange via-amber-300 to-brand-orange bg-clip-text text-transparent`}>
                  Potencia en BT y MT
                </span>
              </h1>
            </div>

            <p
              className={`mt-5 max-w-xl mx-auto md:mx-0 text-center md:text-left ${darkMode ? "text-slate-300/90" : "text-slate-600"
                }`}
            >
              Ingeniería, fabricación, integración y mantenimiento para la gran y pequeña minería e industria. personal con +15 años de experiencia,
              soporte 24/7 y disponibilidad de software para PLC y HMI.
            </p>

            <div className="mt-6 p-4 rounded-2xl border border-brand-orange/30 bg-brand-orange/10 max-w-xl mx-auto md:mx-0">
              <p className={`${darkMode ? "text-slate-100" : "text-slate-800"} text-sm text-center md:text-left`}>
                Objetivo: asegurar <span className="font-semibold">confiabilidad</span> y{" "}
                <span className="font-semibold">disponibilidad</span> de los activos críticos.
              </p>
            </div>

            <p className="mt-6 text-xs text-slate-400 text-center md:text-left">
              B&M Electric Service SPA
            </p>
          </motion.div>

          <motion.div
            {...(reduceMotion
              ? {}
              : { initial: { opacity: 0, scale: 0.98 }, animate: { opacity: 1, scale: 1 }, transition: { duration: 0.5, delay: 0.06 } })}
          >
            <div
              className={`relative rounded-3xl p-6 shadow-2xl border ${darkMode ? "bg-white/5 border-white/10" : "bg-white border-slate-200"
                }`}
            >
              <div className="grid grid-cols-2 gap-4 text-sm">
                {[
                  { t: "Ingeniería de Tableros", d: "Diseño, integración y puesta en marcha." },
                  { t: "Programas de Mantenimiento", d: "Preventivo, predictivo y correctivo." },
                  { t: "PLC / HMI", d: "Backups, mejoras y diagnósticos." },
                  { t: "Mediciones Especializadas", d: "Estudios harmónicos." },
                  { t: "Rectificadores de Potencia", d: "Mantenimiento integral, venta de repuestos, overhaul y revamping." },
                  { t: "Minería e Industria", d: "Soluciones confiables y escalables." },
                ].map((c, i) => (
                  <div
                    key={i}
                    className={`rounded-2xl p-4 border transition ${darkMode
                      ? "bg-white/5 border-white/10 hover:border-brand-orange/40"
                      : "bg-slate-100 border-slate-200 hover:border-brand-orange/40"
                      }`}
                  >
                    <p className={`font-semibold text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
                      {c.t}
                    </p>
                    <p className={`${darkMode ? "text-slate-300" : "text-slate-600"} mt-1 text-center`}>
                      {c.d}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Trabajos / Galería */}
      <section id="actividades" className={`mx-auto max-w-7xl px-6 py-20 border-t ${darkMode ? "border-white/10" : "border-slate-300"}`}>
        <div className="text-center">
          <h2
            className={`text-3xl md:text-4xl font-bold bg-gradient-to-r bg-clip-text text-transparent mb-6 ${darkMode ? "from-white to-white/70" : "from-slate-900 to-slate-700"
              }`}
          >
            Actividades
          </h2>
          <p className={`${darkMode ? "text-slate-300/90" : "text-slate-700"} mt-3`}>
            Selección de algunos de nuestros proyectos y mantenimientos recientes. Haz clic para ampliar.
          </p>
        </div>

        {/* Carruseles por categoría */}
        <div className="mt-8 space-y-12">
          {galleryCategories.map((category, categoryIndex) => (
            <div key={categoryIndex} className="space-y-4">
              {/* Título de la categoría */}
              <h3 className={`text-xl font-semibold text-center ${darkMode ? "text-slate-200" : "text-slate-800"}`}>
                {category.title}
              </h3>
              
              {/* Carrusel de imágenes */}
              <div className="relative">
                {/* Botón anterior */}
                {carouselPositions[categoryIndex] > 0 && (
                  <button
                    onClick={() => handleCarouselPrev(categoryIndex)}
                    className={`absolute left-2 top-1/2 -translate-y-1/2 z-10 rounded-full w-10 h-10 flex items-center justify-center transition ${
                      darkMode 
                        ? "bg-black/50 text-white hover:bg-black/70" 
                        : "bg-white/80 text-slate-800 hover:bg-white shadow-lg"
                    }`}
                    aria-label="Anterior"
                  >
                    <span className="text-lg leading-none">‹</span>
                  </button>
                )}

                {/* Botón siguiente */}
                {carouselPositions[categoryIndex] < Math.max(0, category.items.length - visibleItems) && (
                  <button
                    onClick={() => handleCarouselNext(categoryIndex)}
                    className={`absolute right-2 top-1/2 -translate-y-1/2 z-10 rounded-full w-10 h-10 flex items-center justify-center transition ${
                      darkMode 
                        ? "bg-black/50 text-white hover:bg-black/70" 
                        : "bg-white/80 text-slate-800 hover:bg-white shadow-lg"
                    }`}
                    aria-label="Siguiente"
                  >
                    <span className="text-lg leading-none">›</span>
                  </button>
                )}

                {/* Contenedor del carrusel */}
                <div className="overflow-hidden rounded-2xl">
                  <div 
                    className="flex gap-2 transition-transform duration-300 ease-in-out"
                    style={{ 
                      transform: `translateX(-${carouselPositions[categoryIndex] * (100 / visibleItems)}%)`
                    }}
                  >
                    {category.items.map((item, index) => {
                      return (
                        <div key={index} className="flex-shrink-0" style={{ width: `calc(${100 / visibleItems}% - 4px)` }}>
                          <button
                            type="button"
                            onClick={() => {
                              setLightboxIndex(index);
                              setLightboxCategoryIndex(categoryIndex);
                            }}
                            className={`group relative overflow-hidden rounded-2xl border transition w-full h-64 ${darkMode
                              ? "bg-white/5 border-white/10 hover:border-brand-orange/40"
                              : "bg-white border-slate-200 hover:border-brand-orange/40"
                              }`}
                          >
                            <img
                              src={item.src}
                              alt={item.alt}
                              loading="lazy"
                              decoding="async"
                              className="h-64 w-full object-cover transition duration-300 group-hover:scale-[1.02]"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition" />
                            <div className="absolute bottom-0 left-0 right-0 p-3 text-left">
                              <p className="text-white text-sm font-semibold drop-shadow">{item.caption}</p>
                            </div>
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {lightboxIndex !== null && lightboxCategoryIndex !== null && (
          <div
            className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto"
            onClick={() => {
              setLightboxIndex(null);
              setLightboxCategoryIndex(null);
            }}
          >
            <div className="relative max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
              {/* Botón cerrar (siempre visible) */}
              <button
                type="button"
                className="absolute top-2 right-2 z-10 rounded-full p-2 bg-black/50 text-white hover:bg-black/60"
                onClick={() => {
                  setLightboxIndex(null);
                  setLightboxCategoryIndex(null);
                }}
                aria-label="Cerrar"
              >
                ✕
              </button>

              {/* Botón anterior */}
              <button
                type="button"
                className="absolute left-2 top-1/2 -translate-y-1/2 z-10 rounded-full w-10 h-10 flex items-center justify-center bg-black/50 text-white hover:bg-black/60"
                onClick={() =>
                  setLightboxIndex((prev) => {
                    const currentCategory = galleryCategories[lightboxCategoryIndex];
                    const next = (prev - 1 + currentCategory.items.length) % currentCategory.items.length;
                    return next;
                  })
                }
                aria-label="Anterior"
              >
                <span className="text-lg leading-none">‹</span>
              </button>

              {/* Botón siguiente */}
              <button
                type="button"
                className="absolute right-2 top-1/2 -translate-y-1/2 z-10 rounded-full w-10 h-10 flex items-center justify-center bg-black/50 text-white hover:bg-black/60"
                onClick={() =>
                  setLightboxIndex((prev) => {
                    const currentCategory = galleryCategories[lightboxCategoryIndex];
                    const next = (prev + 1) % currentCategory.items.length;
                    return next;
                  })
                }
                aria-label="Siguiente"
              >
                <span className="text-lg leading-none">›</span>
              </button>

              <img
                src={galleryCategories[lightboxCategoryIndex]?.items[lightboxIndex]?.src}
                alt={galleryCategories[lightboxCategoryIndex]?.items[lightboxIndex]?.alt || "Trabajo"}
                className="w-full h-auto max-h-[80vh] object-contain rounded-xl shadow-2xl"
              />
              <div className="mt-3 text-white/90 text-sm">
                <p>{galleryCategories[lightboxCategoryIndex]?.items[lightboxIndex]?.caption}</p>
              </div>
            </div>
          </div>
        )}
      </section>


      {/* Clientes */}
      <section id="clientes" className={`mx-auto max-w-7xl px-6 py-20 border-t ${darkMode ? "border-white/10" : "border-slate-300"}`}>
        <div className="text-center">
          <h2
            className={`text-3xl md:text-4xl font-bold bg-gradient-to-r bg-clip-text text-transparent mb-6 ${darkMode ? "from-white to-white/70" : "from-slate-900 to-slate-700"
              }`}
          >
            Clientes
          </h2>
          <p className={`${darkMode ? "text-slate-300/90" : "text-slate-600"} mt-3 p-1`}>
            Empresas con las que hemos trabajado.
          </p>
        </div>

        <div className="mt-10" style={{ contentVisibility: 'auto', containIntrinsicSize: '1px 400px' }}>
          <div className={`rounded-2xl p-6 border ${darkMode ? "bg-white/5 border-white/10" : "bg-white border-slate-200"}`}>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {allClientes.map((name, idx) => (
                <div key={idx} className={`rounded-xl border overflow-hidden ${darkMode ? "bg-white/5 border-white/10" : "bg-white border-slate-200"}`}>
                  <img
                    src={logoFor(name)}
                    alt={name}
                    loading="lazy"
                    decoding="async"
                    className={`h-20 sm:h-24 w-full object-contain p-3 sm:p-4 ${!darkMode && name === "GE Power" ? "invert" : ""}`}
                  />
                  <div className={`px-3 sm:px-4 pb-3 text-center text-xs sm:text-sm ${darkMode ? "text-slate-200" : "text-slate-700"}`}>{name}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Servicios para Rectificadores */}
      <section id="servicios-rectificadores" className="mx-auto max-w-7xl px-6 py-20 text-center">
        <h2
          className={`text-3xl md:text-4xl font-bold bg-gradient-to-r bg-clip-text text-transparent mb-6 p-1 ${darkMode ? "from-white to-white/70" : "from-slate-900 to-slate-700"
            }`}
        >
          Servicios para Rectificadores
        </h2>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" style={{ contentVisibility: 'auto', containIntrinsicSize: '1px 600px' }}>
          {/* Sistema de Potencia */}
          <div className={`rounded-2xl p-6 border ${darkMode ? "bg-white/5 border-white/10" : "bg-white border-slate-200"}`}>
            <h3 className={`text-xl font-semibold mb-6 text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
              Sistema de Potencia
            </h3>
            <div className="space-y-3">
              {[
                "Medición de distribución de corriente y mejora de desbalances entre tiristores",
                "Medición preventiva en transformadores de potencia",
                "Mediciones de formas de ondas características en un rectificador doble estrella, tipo puente y otros",
                "Termografías",
                "Contratación de sistema de medición de corriente DC"
              ].map((service, index) => (
                <div key={index} className={`p-3 rounded-lg transition hover:scale-[1.02] ${darkMode ? "bg-white/5 hover:border-brand-orange/40" : "bg-slate-100 hover:border-brand-orange/40"}`}>
                  <p className={`font-semibold text-sm text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
                    {service}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Sistema de Refrigeración */}
          <div className={`rounded-2xl p-6 border ${darkMode ? "bg-white/5 border-white/10" : "bg-white border-slate-200"}`}>
            <h3 className={`text-xl font-semibold mb-6 text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
              Sistema de Refrigeración
            </h3>
            <div className="space-y-3">
              {[
                "Conductividad de agua y cambio/retrolavado",
                "Verificación de mangueras, disipadores y sensores (PT100, flujómetro)",
                "Ajuste de protecciones en bombas y ventilación",
                "Limpieza e inspección de intercambiadores"
              ].map((service, index) => (
                <div key={index} className={`p-3 rounded-lg transition hover:scale-[1.02] ${darkMode ? "bg-white/5 hover:border-brand-orange/40" : "bg-slate-100 hover:border-brand-orange/40"}`}>
                  <p className={`font-semibold text-sm text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
                    {service}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Sistema de Control */}
          <div className={`rounded-2xl p-6 border ${darkMode ? "bg-white/5 border-white/10" : "bg-white border-slate-200"}`}>
            <h3 className={`text-xl font-semibold mb-6 text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
              Sistema de Control
            </h3>
            <div className="space-y-3">
              {[
                "Respaldo de programas (PLC/HMI)",
                "Pruebas de lógica de operación, señales alarma y Trip (celda MT, transformador, fusibles, temperatura, sistemas de enfriamiento y otros)",
                "Verificación del estado general de los gabinetes"
              ].map((service, index) => (
                <div key={index} className={`p-3 rounded-lg transition hover:scale-[1.02] ${darkMode ? "bg-white/5 hover:border-brand-orange/40" : "bg-slate-100 hover:border-brand-orange/40"}`}>
                  <p className={`font-semibold text-sm text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
                    {service}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Tarjetas Electrónicas */}
          <div className={`rounded-2xl p-6 border ${darkMode ? "bg-white/5 border-white/10" : "bg-white border-slate-200"}`}>
            <h3 className={`text-xl font-semibold mb-6 text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
              Tarjetas Electrónicas
            </h3>
            <div className="space-y-3">
              {[
                "Sincronismo y pulsos de disparo",
                "Verificación del lazo de control de corriente"
              ].map((service, index) => (
                <div key={index} className={`p-3 rounded-lg transition hover:scale-[1.02] ${darkMode ? "bg-white/5 hover:border-brand-orange/40" : "bg-slate-100 hover:border-brand-orange/40"}`}>
                  <p className={`font-semibold text-sm text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
                    {service}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Equipos de Maniobra */}
          <div className={`rounded-2xl p-6 border ${darkMode ? "bg-white/5 border-white/10" : "bg-white border-slate-200"}`}>
            <h3 className={`text-xl font-semibold mb-6 text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
              Equipos de Maniobra
            </h3>
            <div className="space-y-3">
              {[
                "Estado y operatividad de seccionadores DC",
                "Estado y operatividad de celdas MT"
              ].map((service, index) => (
                <div key={index} className={`p-3 rounded-lg transition hover:scale-[1.02] ${darkMode ? "bg-white/5 hover:border-brand-orange/40" : "bg-slate-100 hover:border-brand-orange/40"}`}>
                  <p className={`font-semibold text-sm text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
                    {service}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Asistencia 24/7 */}
          <div className={`rounded-2xl p-6 border ${darkMode ? "bg-white/5 border-white/10" : "bg-white border-slate-200"}`}>
            <h3 className={`text-xl font-semibold mb-6 text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
              Asistencia 24/7
            </h3>
            <div className="space-y-3">
              {[
                "Telefónica o en sitio"
              ].map((service, index) => (
                <div key={index} className={`p-3 rounded-lg transition hover:scale-[1.02] ${darkMode ? "bg-white/5 hover:border-brand-orange/40" : "bg-slate-100 hover:border-brand-orange/40"}`}>
                  <p className={`font-semibold text-sm text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
                    {service}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Tableros y Control */}
      <section id="tableros" className={`mx-auto max-w-7xl px-6 py-20 border-t ${darkMode ? "border-white/10" : "border-slate-300"}`}>
        <div className="text-center mb-12">
          <h2
            className={`text-3xl md:text-4xl font-bold bg-gradient-to-r bg-clip-text text-transparent mb-6 p-1 ${darkMode ? "from-white to-white/70" : "from-slate-900 to-slate-700"
              }`}
          >
            Tableros de Control y Fuerza
          </h2>
          <p className={`mt-3 max-w-3xl mx-auto ${darkMode ? "text-slate-300/90" : "text-slate-600"}`}>
            Ingeniería y diseño, integración en salas eléctricas, montaje, comisionamiento y puesta en marcha.
            Mantenimientos preventivos y correctivos.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8" style={{ contentVisibility: 'auto', containIntrinsicSize: '1px 600px' }}>
          {/* Servicios Principales */}
          <div className="lg:col-span-2">
            <div className={`rounded-2xl p-6 border h-full transition ${darkMode ? "bg-white/5 border-white/10 hover:border-brand-orange/40" : "bg-white border-slate-200 hover:border-brand-orange/40"}`}>
              <h3 className={`text-xl font-semibold mb-6 text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
                Servicios Principales
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  {
                    title: "Diseño de Tableros",
                    desc: "Diseño de tableros eléctricos y sistemas de control"
                  },
                  {
                    title: "Integración Industrial", 
                    desc: "Integración y cableado industrial especializado"
                  },
                  {
                    title: "Automatización",
                    desc: "Automatización con PLC/HMI y sistemas SCADA"
                  },
                  {
                    title: "Estaciones Remotas",
                    desc: "Estaciones remotas y sistemas de medición"
                  },
                  {
                    title: "Backups y Mejoras",
                    desc: "Backups y mejoras de programas existentes"
                  },
                  {
                    title: "Mantenimiento",
                    desc: "Mantenimientos preventivos y correctivos"
                  }
                ].map((service, index) => (
                  <div key={index} className={`p-3 rounded-lg transition hover:scale-[1.02] ${darkMode ? "bg-white/5 hover:border-brand-orange/40" : "bg-slate-100 hover:border-brand-orange/40"}`}>
                    <h4 className={`font-semibold text-sm mb-1 ${darkMode ? "text-white" : "text-slate-900"}`}>
                      {service.title}
                    </h4>
                    <p className={`text-xs ${darkMode ? "text-slate-300" : "text-slate-600"}`}>
                      {service.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Casos Típicos */}
          <div className="lg:col-span-1">
            <div className={`rounded-2xl p-6 border h-full transition hover:border-brand-orange/40 ${darkMode ? "bg-white/5 border-white/10" : "bg-white border-slate-200"}`}>
              <h3 className={`text-xl font-semibold mb-6 text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
                Casos Típicos
              </h3>
              <div className="space-y-4">
                {[
                  {
                    title: "Modernización HMI",
                    desc: "Modernización de HMI y controladores con migración segura de lógicas"
                  },
                  {
                    title: "Diagnóstico Avanzado",
                    desc: "Diagnóstico de variables de proceso y fallas intermitentes"
                  },
                  {
                    title: "Comisionamiento",
                    desc: "Comisionamiento de pruebas FAT/SAT y puesta en marcha"
                  }
                ].map((case_item, index) => (
                  <div key={index} className={`p-3 rounded-lg transition hover:scale-[1.02] ${darkMode ? "bg-white/5 hover:border-brand-orange/40" : "bg-slate-100 hover:border-brand-orange/40"}`}>
                    <h4 className={`font-semibold text-sm mb-1 ${darkMode ? "text-white" : "text-slate-900"}`}>
                      {case_item.title}
                    </h4>
                    <p className={`text-xs ${darkMode ? "text-slate-300" : "text-slate-600"}`}>
                      {case_item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mantenimiento */}
      <section id="mantenimiento" className={`mx-auto max-w-7xl px-6 py-20 border-t ${darkMode ? "border-white/10" : "border-slate-300"} text-center`}>
        <h2
          className={`text-3xl md:text-4xl font-bold bg-gradient-to-r bg-clip-text text-transparent mb-6 p-1 ${darkMode ? "from-white to-white/70" : "from-slate-900 to-slate-700"
            }`}
        >
          Programas de Mantenimiento
        </h2>
        <p className={`mt-3 max-w-3xl mx-auto ${darkMode ? "text-slate-300/90" : "text-slate-700"}`}>
          Planes preventivos y predictivos con reportabilidad, mediciones simultáneas en tiristores,
          respaldo de software y calibraciones.
        </p>

        <div className="mt-10 grid md:grid-cols-3 gap-6 text-left" style={{ contentVisibility: 'auto', containIntrinsicSize: '1px 500px' }}>
          {[
            { t: "Preventivo", p: "Tareas programadas, revisión de componentes eléctricos, catastro de repuestos críticos y respaldo de programas (PLC y HMI)." },
            { t: "Predictivo", p: "Análisis de variables características y tendencias." },
            { t: "Emergencia", p: "Respuesta prioritaria y especialistas." },
          ].map((c, i) => (
            <div
              key={i}
              className={`rounded-2xl p-6 border transition ${darkMode ? "bg-white/5 border-white/10 hover:border-brand-orange/40" : "bg-white border-slate-200 hover:border-brand-orange/40"
                }`}
            >
              <h3 className={`font-semibold text-lg text-center ${darkMode ? "text-white" : "text-slate-900"}`}>
                {c.t}
              </h3>
              <p className={`${darkMode ? "text-slate-300" : "text-slate-600"} mt-2 text-sm text-center`}>{c.p}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA / Contacto */}
      <section id="contacto" className="mx-auto max-w-7xl px-6 pb-24">
        <div className="rounded-3xl border border-brand-orange/30 bg-brand-orange/10 p-8 md:p-10 shadow-2xl">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="text-center md:text-center">
              <h2
                className={`text-3xl md:text-4xl font-bold bg-gradient-to-r bg-clip-text text-transparent mb-6 ${darkMode ? "from-white to-white/80" : "from-slate-900 to-slate-700"
                  }`}
              >
                Contacto
              </h2>
              <p className={`${darkMode ? "text-slate-200" : "text-slate-800"} mt-3`}>
                Cotiza tu mantenimiento o proyecto de automatización.
              </p>
              <div className="mt-4 flex flex-col sm:flex-row gap-3 justify-center">
                <a
                  href={`https://wa.me/${WHATSAPP_ERIC.replace('+', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-green-600 text-white font-medium hover:bg-green-700 transition-all duration-200 shadow-md hover:shadow-lg text-sm"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                  </svg>
                  <span>Eric Barrientos - WhatsApp</span>
                </a>
                <a
                  href={`https://wa.me/${WHATSAPP_RAFAEL.replace('+', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-green-600 text-white font-medium hover:bg-green-700 transition-all duration-200 shadow-md hover:shadow-lg text-sm"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                  </svg>
                  <span>Rafael Mardones - WhatsApp</span>
                </a>
              </div>
            </div>

            <form
              onSubmit={handleContactSubmit}
              className={`rounded-2xl p-6 space-y-4 border ${darkMode ? "bg-white/5 border-white/10" : "bg-white border-slate-200"
                }`}
              style={{ contentVisibility: 'auto', containIntrinsicSize: '1px 420px' }}
            >
              <div>
                <label className={`block text-sm mb-1 ${darkMode ? "text-slate-200" : "text-slate-700"}`}>Nombre</label>
                <input
                  value={contactName}
                  onChange={(e) => setContactName(e.target.value)}
                  className={`w-full rounded-lg px-3 py-2 outline-none placeholder:text-slate-400 border ${darkMode
                    ? "bg-white/5 border-white/10 focus:border-brand-orange text-white"
                    : "bg-white border-slate-300 focus:border-brand-orange text-slate-900"
                    }`}
                  placeholder="Tu nombre"
                />
              </div>
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label className={`block text-sm mb-1 ${darkMode ? "text-slate-200" : "text-slate-700"}`}>Email</label>
                  <input
                    type="email"
                    value={contactEmail}
                    onChange={(e) => setContactEmail(e.target.value)}
                    className={`w-full rounded-lg px-3 py-2 outline-none placeholder:text-slate-400 border ${darkMode
                      ? "bg-white/5 border-white/10 focus:border-brand-orange text-white"
                      : "bg-white border-slate-300 focus:border-brand-orange text-slate-900"
                      }`}
                    placeholder="tu@empresa.com"
                  />
                </div>
                <div>
                  <label className={`block text-sm mb-1 ${darkMode ? "text-slate-200" : "text-slate-700"}`}>Teléfono</label>
                  <input
                    value={contactPhone}
                    onChange={(e) => setContactPhone(e.target.value)}
                    className={`w-full rounded-lg px-3 py-2 outline-none placeholder:text-slate-400 border ${darkMode
                      ? "bg-white/5 border-white/10 focus:border-brand-orange text-white"
                      : "bg-white border-slate-300 focus:border-brand-orange text-slate-900"
                      }`}
                    placeholder="+56 9 ..."
                  />
                </div>
              </div>
              <div>
                <label className={`block text-sm mb-1 ${darkMode ? "text-slate-200" : "text-slate-700"}`}>Mensaje</label>
                <textarea
                  rows={4}
                  value={contactMessage}
                  onChange={(e) => setContactMessage(e.target.value)}
                  className={`w-full rounded-lg px-3 py-2 outline-none placeholder:text-slate-400 border ${darkMode
                    ? "bg-white/5 border-white/10 focus:border-brand-orange text-white"
                    : "bg-white border-slate-300 focus:border-brand-orange text-slate-900"
                    }`}
                  placeholder="Cuéntanos tu necesidad"
                />
              </div>
              <button
                type="submit"
                className="w-full rounded-2xl bg-gradient-to-r from-brand-orange to-brand-green text-white font-semibold px-4 py-3 transition hover:brightness-105 shadow-[0_12px_30px_-12px_rgba(232,97,44,0.7)]"
              >
                Solicitar cotización
              </button>
              <p className={`${darkMode ? "text-slate-300" : "text-slate-700"} text-xs`}>
                Al enviar aceptas ser contactado por nuestro equipo.
              </p>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className={`border-t ${darkMode ? "border-white/10" : "border-slate-300"}`}>
        <div
          className={`mx-auto max-w-7xl px-6 py-6 text-sm flex flex-col md:flex-row gap-2 md:items-center md:justify-between ${darkMode ? "text-slate-400" : "text-slate-600"
            }`}
        >
          <p>© {new Date().getFullYear()} B&M Electric Service SPA</p>
          <p>Ingeniería, fabricación, integración y mantenimiento • Minería e industria</p>
        </div>
      </footer>
    </div>
  );
}
